// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"cE-z","smallCardRow":"dE-z","largeCardRow":"eE-z","productSearchRow":"fE-z","curatedRow":"gE-z"};